import ColorPickerSwatch from './color-picker-swatch.vue.js';
import TravelMixin from '../../../mixins/travel.js';
import { DEFAULT_PRESETS } from '../utils.js';
import { isValidHex } from '../../../utils/color.js';

var script = {
  name: 'PendoColorPickerPresets',
  components: {
    ColorPickerSwatch
  },
  mixins: [TravelMixin],
  $travel: {
    refName: 'color-preset'
  },
  props: {
    value: {
      type: String,
      default: null,
      validator: value => isValidHex(value)
    },
    presets: {
      type: Array,
      default: () => DEFAULT_PRESETS
    },
    size: {
      type: Number,
      default: 16
    }
  },
  methods: {
    onPresetSelect(color) {
      this.$emit('change', color);
    }
  }
};

export { script as default };
//# sourceMappingURL=pendo-color-picker-presets.vue2.js.map
